export default __webpack_public_path__ + "static/media/t25.min.a22700ae.png";